<template>
    <div>
        <Modal
            class-name="vertical-center-modal"
            :value="showModel"
            :title="title"
            :footer-hide="true"
            :mask-closable="false"
            @on-cancel="cancel"
            @on-visible-change="openOrClose"  :styles="{'min-width':'600px'}">
            
            <Form ref="formData" :model="formData" :rules="ruleCustom" :label-width="700" label-position="top">
                
                <FormItem :label="$t('setting.companyName')" prop="companyName" style="width: 560px">
                    <Radio v-model="formData.all"></Radio>
                </FormItem>
    
                <FormItem :label="$t('setting.email')" prop="email" style="width: 560px">
                    <Input type="text" v-model.trim="formData.email" :placeholder="$t('inputPlaceholder')" ></Input>
                </FormItem>
    
                <FormItem :label="$t('setting.macMaker')" prop="macMaker" style="width: 560px">
                    <Input type="text" v-model.trim="formData.macMaker"  maxlength="6"  :placeholder="$t('inputPlaceholder')"></Input>
                </FormItem>
    
                
    
                <FormItem class="operWrap">
                    <Button :loading="disabled"  type="primary" @click="subData('formData')" style="margin-right:20px">{{$t('save')}}</Button>
                    <Button :disabled="disabled" @click="cancel">{{$t('cancel')}}</Button>
                </FormItem>
            </Form>
    
        </Modal>
    </div>
    </template>
    <script>
    /**
     * 弹框
     * @param showModel boolean 对话框开关 true false
     * @param fn function 回调函数
     * @param type Number 类型 1添加 2编辑
     * @param editFormData Object 编辑时的数据
     */
    import common from '@/common/common';
    import ImgUpload from "@/views/common/upload";
    import { mapState } from 'vuex'
        export default {
            props: {
                showModel: Boolean,
                fn:Function,
                type:Number,
                editFormData:Object
            },
            name: "Model3",
            components: {
                ImgUpload
            },
            data() {
                return {   
                    uploadUsersAvatar:this.config.urlArray.uploadImg, //上传图片接口
                     hasUpload: [], //已上传图片
                    disabled: false,//禁用确定按钮
                    title: '',//弹框标题
                    formData: {//表单数据
                        brandName:'',
                        companyAddress:'',
                        companyName:'', 
                    }
                }
            },
            watch:{},
            computed:{
                ...mapState(['local','selectId']),
                selectObj(){
                    return {
                        languageList:[
                            {id: 'zh_CN',val:this.$t('zh_CN')},
                            {id: 'en_US',val:this.$t('en_US')}
                        ]
                    }
                },
                 ruleCustom(){
                     return {//验证
                        companyName: [
                            {required: true, message:this.$t('required'),trigger: 'blur' },
                        ],
                        email: [
                            {required: true, message:this.$t('required'),trigger: 'blur' },
                            {type: 'string', pattern: /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/, message: this.$t('ruleCustom.format'), trigger:'blur'},
                        ],
                        brandName: [
                            {required: true, message:this.$t('required'),trigger: 'blur' },
                        ]
                    }
                 } 
    
            },
            created(){
               
            },
            methods: {
                openOrClose(value) {
                    if(value === true) {
                        this.title = this.$t('seceneManage.addModel.addtionBoX.title')
                    } else {
                        this.resetForm();
                        this.$refs.upLogoImg.clearImg()
                    }
                },
                 setThumbUrlthumb(item) {
                  this.formData.imageFid = item.data;
                //   this.formData.log = this.config.sourceUrl+'?fid='+item.data
                },
                removeThumbUrl(){
                    this.formData.imageFid = '';
                },
                subData(name) {//提交表单
                    // console.log('this.formData',this.formData)
                    this.$refs[name].validate((valid) => {
                        if (valid) {
                            this.disabled = true; 
                            this.axios.post(this.config.urlArray.addDealer, this.formData).then((result) => {
                                common.ajaxMsg(result.data,true,()=>{
                                    this.resetForm();
                                    this.fn()
                                },()=>{this.disabled = false})
                                
                            }).catch((err) => {
                                // this.disabled = false;
                            });
                            
                        }
                    })
                },
                cancel() {//对话框关闭
                    this.$emit('update:showModel',false);
                },
                resetForm() {//重置表单
                    this.$refs.formData.resetFields();//重置表单
                    this.formData.imageFid = ''
                    this.disabled = false;//恢复提交按钮为激活状态
                }
            }
        }
    </script>
    